import { useNavigate } from "react-router-dom";
import "../styles/welcome_page.css";
import GradientButton from "../Components/Button/GradientButton";
import m3Logo from "../assets/logos/M3_Logo.png";
import { useEffect, useState } from "react";
import LoginModal from "../Components/LoginModal/LoginModal";

const WelcomePage = ({ isSignIn = false }) => {
  const navigate = useNavigate();
  const [loginModal, setLoginModal] = useState(isSignIn);
  const handleModalClose = () => setLoginModal(false);

  useEffect(() => {
    // console.log("");
  }, []);

  return (
    <div className="welcome_container px-10 pb-4">
      <LoginModal
        open={loginModal}
        onOk={() => {}}
        onCancel={handleModalClose}
      />
      <div className="flex justify-end items-center gap-x-10 w-full h-16 pr-3 pt-14">
        {/* <p className="cursor-pointer text-white hover:text-gray-200 sm:text-xl sm:font-bold" onClick={()=>navigate("/signup")}>Sign up</p> */}
        {/* <GradientButton className="rounded-xl px-6 sm:px-8 py-2 sm:text-xl" onClick={()=>setLoginModal(true)}>Login</GradientButton> */}
      </div>
      <div className="mt-12 flex flex-col items-center">
        <div className="">
          <img src={m3Logo} width={360} />
        </div>
        <p className="text-gradient text-5xl font-bizmo font-light italic text-center">
          Welcome to Mawhiba Meta Minds
        </p>
        <p className=" text-white z-50 text-center mt-6">
          At Our Platform, we are dedicated to providing you with the best
          service possible. Whether you are here to explore new opportunities,
          connect with others, or learn something new, we are excited to have
          you with us. Get ready to dive into a world of innovation and growth.
          We're constantly updating our offerings to ensure you have access to
          the latest and greatest features.
        </p>
        <div className="z-50 mt-16">
          <GradientButton
            className="bg-gradient-to-l hover:bg-gradient-to-bl rounded-xl px-12"
            onClick={() => navigate("/")}
          >
            Get Started
          </GradientButton>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
